import React from 'react'

const StaticHeaderSpacer = () => {
    return (
        <>
            <style type="text/css" dangerouslySetInnerHTML={{
                __html: `
                    .s-sp {
                        padding-top: 5.5rem;
                    }
                    @media (min-width: 913px) {
                        .s-sp {
                            padding-top: 9.5rem;
                        }
                    }
                `
            }} />
            <div className="s-sp" />
        </>
    )
}

export default StaticHeaderSpacer
